import styled, { css } from "styled-components";

let Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    box-sizing: border-box;
    padding: 32px 20px;
    background-color: #ffffff;
    ${(props) => {
        switch (props.typeBg) {
            case "background-color":
                return css`
                    background-color: ${props => props.bg};
                `;
            case "background-image":
                return css`
                    background-image: url(${props => props.bg});
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                `;
            default:
                return css`
                    background-color: #ffffff;
                `;
        }
      }}
`;

const LoginScreen = styled.div`
    display: grid;
    height: 100vh;
    height: 100dvh;
    grid-template-rows: minmax(0, 1fr) calc(40px + env(safe-area-inset-bottom, 0px));
    background-color: #ffffff;

    > ${Container} {
        min-height: 0;
        overflow-y: auto;
        scroll-padding: 8px;
        justify-content: safe center;
    }

    > ${Container} .flat-button-container {
        transform: translateX(15px);
    }

    > .position-spin {
        position: static;
        transform: none;
        display: grid;
        place-items: center;
    }
`;

const AppVersion = styled.small`
    position: fixed;
    right: max(12px, env(safe-area-inset-right, 0px));
    bottom: max(12px, env(safe-area-inset-bottom, 0px));
    color: #9CA3AF;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0;
    white-space: nowrap;
    pointer-events: none;
`;

let Logo = styled.img`
    display: block;
    width: min(70%, 320px);
    max-width: 100%;
    height: 96px;
    object-fit: contain;
    margin: 0 auto;
`;

let Texthome = styled.span`
    align-self: flex-end;
    margin-bottom: 1%;
    width: 24%;
    font-size: 14px;
    font-weight: 500;
    line-height: 26px;
    color: #888888;
    
    @media screen and (min-width: 1920px ){
        font-size: 24px;
    }

    @media screen and (max-width: 1920px ) and (min-width: 1732px){
        font-size: 22px;
    }

    @media screen and (max-width: 1731px ) and (min-width: 1680px){
        font-size: 20px;
    }

    @media screen and (max-width: 991px ) and (min-width: 740px){
        width: 40%;
    }

    @media screen and (max-width: 740px ) and (min-width: 637px){
        width: 40%;
    }

    @media screen and (max-width: 636px ) and (min-width: 486px){
        width: 60%;
    }

    @media screen and (max-width: 486px){
        width: 80%;
    }
`;

let Ssocard = styled.div `
    width: min(100%, 640px);
    box-sizing: border-box;
    flex-shrink: 0;
    margin: 0 auto;
    padding: 44px 40px;
    border: none;
    border-radius: 6px;
    background-color: rgba(255, 255, 255, 0.88);
    box-shadow: none;

    @media screen and (max-width: 480px){
        padding: 32px 20px;
    }
`
const Subcard = styled.div`
    display: block;
    width: 100%;
    margin-top: 0;
`;

const Texthead = styled.h1`
    font-weight: 600;
    font-size: 28px;
    line-height: 1.3;
    letter-spacing: 0;
    text-align: center;
    overflow-wrap: anywhere;
    margin: 32px 0 28px;
    color: #000000;
`;

const Textsubhead = styled.p`
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.1em;
    color: #000000;
    text-align: left;
    margin: 0 auto 5.38% ;
    width:80%;
    @media screen and (min-width: 1920px ){
        font-size: 22px;
    }

    @media screen and (max-width: 1919px ) and (min-width: 1732px){
        font-size: 22px;
    }

    @media screen and (max-width: 1731px ) and (min-width: 1680px){
        font-size: 22px;
    }

    @media screen and (max-width: 1680px ) and (min-width: 1537px){
        font-size: 20px;
    }

    @media screen and (max-width: 1536px ) and (min-width: 1441px){
        font-size: 18px;
    }

    @media screen and (max-width: 1340px ) and (min-width: 740px){
        width:70%;
    }
`;

export {Container , Ssocard, Logo, Texthome, Subcard, Texthead, Textsubhead, LoginScreen, AppVersion};